import React from 'react';
import Media from 'react-media';
import MediaBorders from 'constants/media-borders';
import { applyStyles } from 'util/helpers';

const Input = ({ input, meta, type, ...inputProps }) => (
  <input
    {...input}
    {...inputProps}
    onBlur={() => {
      inputProps.onBlur && inputProps.onBlur(input.value);
      input.onBlur();
    }}
    onChange={event => {
      input.onChange(event.nativeEvent.target.value);
      inputProps.onChange &&
        inputProps.onChange(event.nativeEvent.target.value);
    }}
    onKeyDown={event => {
      inputProps.onKeyDown && inputProps.onKeyDown(event);
    }}
    type={type || 'hidden'}
  />
);

const PCInputContainer = ({ className, notes, meta, ...input }) => (
  <div className={className}>
    <Input meta={meta} {...input} />
    {notes && (
    <ul className="notes">
        {notes.map((note, index) => (
        <li key={index}>{note}</li>
        ))}
    </ul>
    )}
  </div>
);

const SPInputContainer = ({ className, meta, notes, ...input }) => (
  <div className={className}>
    <Input meta={meta} {...input} />
    {notes && (
      <ul className="notes">
        {notes.map((note, index) => (
          <li key={index}>{note}</li>
        ))}
      </ul>
    )}
  </div>
);

const StyledPCInputContainer = applyStyles(PCInputContainer)();
const StyledSPInputContainer = applyStyles(SPInputContainer)();

const InputContainer = ({ input, meta, inputProps }) => (
  <Media
    query={`(min-width: ${MediaBorders.umedium})`}
    children={matches =>
      matches ? (
        <StyledPCInputContainer input={input} meta={meta} {...inputProps} />
      ) : (
        <StyledSPInputContainer input={input} meta={meta} {...inputProps} />
      )
    }
  />
);

export default InputContainer;



// WEBPACK FOOTER //
// ./src/components/common/HiddenField/components/InputContainer.js